import Storage from '../../../services/Storage';

const MenuItemsRoot = [
  {
    title: 'Aperçu',
    icon: 'home',
    href: '/app/home',
  },
  {
    title: 'Tâches',
    icon: 'box',
    href: '/app/tache',
    target: 'tache',
    action: 'consulter',
  },
  {
    title: 'Clients',
    icon: 'users',
    href: '/app/clients',
    target: 'client',
    action: 'consulter',
  },
  {
    title: 'rendez-vous',
    icon: 'calendar',
    href: '/app/rdv',
    target: 'rdv',
    action: 'consulter',
  },
  {
    title: 'Vente privée',
    icon: 'calendar',
    href: '/app/vp',
    action: 'consulter',
  },
  {
    title: 'Vente privée Scan',
    icon: 'cpu',
    href: '/app/vp/scan',
    action: 'consulter',
  },
  {
    title: 'Whatsapp',
    icon: 'message-circle',
    href: '/app/wsp',
    action: 'consulter',
  },

  {
    title: 'Configuration',
    icon: 'settings',
    collapse: true,
    children: [
      {
        title: 'Utilisateurs',
        icon: 'user',
        href: '/app/users',
        target: 'user',
        action: 'consulter',
        is_root: true,
      },
      {
        title: 'Fournisseurs',
        icon: 'truck',
        href: '/app/fournisseurs',
        target: 'fournisseur',
        action: 'consulter',
      },
      {
        title: 'Groupe Magasins',
        icon: 'briefcase',
        href: '/app/groupe-magasins',
        target: 'magasin',
        action: 'consulter',
      },
      {
        title: 'Magasins',
        icon: 'briefcase',
        href: '/app/magasins',
        target: 'magasin',
        action: 'consulter',
      },
    ],
  },

  {
    title: 'Sécurité',
    icon: 'shield',
    href: '/security',
    is_root: true,
    collapse: true,
    children: [
      {
        title: 'Permissions',
        icon: 'target',
        href: '/app/security/rules',
      },
      // {
      //   title: 'Confidentialité',
      //   icon: 'lock',
      //   href: '/app/security/confid',
      // },
    ],
  },

  {
    title: 'Catalogue',
    icon: 'book',
    href: '/app/catalogue/',
    target: 'catalogue',
    action: 'consulter',
    collapse: true,
    children: [
      {
        title: 'Produit',
        icon: 'list',
        href: '/app/catalogues',
        action: 'consulter',
      },
      {
        title: 'Paramétres',
        icon: 'settings',
        href: '/app/catalogues/settings',
        is_root: true,
      },
      {
        title: 'Cours Métaux',
        icon: 'settings',
        href: '/app/catalogues/cours-metaux',
        is_root: true,
      },
    ],
  },

  {
    title: 'Commandes',
    icon: 'shopping-cart',
    href: '/app/achat',
    target: 'commande',
    action: 'consulter',
  },
  {
    title: 'Commandes Alertes',
    icon: 'alert-circle',
    href: '/app/achat/alerts',
    target: 'commande',
    action: 'consulter',
  },
  {
    title: 'Expédition',
    icon: 'truck',
    href: '/app/expedition',
    target: 'commande',
    action: 'expedier',
  },

  {
    title: 'Arrivages',
    icon: 'package',
    href: '/app/arrivage',
    target: 'commande',
    action: 'cq',
  },
  {
    title: 'Demmande Réassort',
    icon: 'box',
    href: '/app/dmd-reassort',
    target: 'commande',
    action: 'commander',
  },

  {
    title: 'Diamant',
    icon: 'award',
    href: '/app/stock-diamant',
    target: 'diamant',
    action: 'consulter',
    collapse: true,
    children: [
      {
        title: 'Catalogue diamant',
        icon: 'list',
        href: '/app/catalogues/pierres',
        action: 'consulter',
      },
      {
        title: 'Stock diamant',
        icon: 'list',
        href: '/app/stock-diamant',
        action: 'consulter',
      },
      {
        title: 'Mouvement diamant',
        icon: 'truck',
        href: '/app/stock-diamant-fb/mvm',
        action: 'mvm',
      },
      // {
      //   title: 'Stock Diamant FB',
      //   icon: 'settings',
      //   href: '/app/stock-diamant-fb',
      //   action: 'mvm',
      // },
      {
        title: 'Document diamant',
        icon: 'file-text',
        href: '/app/stock-diamant/doc',
        action: 'saisie',
      },
      {
        title: 'Inventaire diamant',
        icon: 'check-circle',
        href: '/app/stock-diamant/inventaire',
        action: 'inventaire',
      },

      {
        title: 'Stock tampon & alerts',
        icon: 'alert-circle',
        href: '/app/stock-diamant/stock-tampon',
        action: 'consulter',
      },
    ],
  },

  {
    title: 'Caisse',
    icon: 'credit-card',
    href: '/app/caisse',
    target: 'caisse',
    action: 'commander',
  },
];

const MenuItemsFb = [
  {
    title: 'Catalogue',
    icon: 'book',
    href: '/app-frn/catalogue',
    action: 'consulter',
  },
  {
    title: 'Commandes',
    icon: 'shopping-cart',
    href: '/app-frn/commande',
    target: 'commande',
    action: 'consulter',
  },
  {
    title: 'Stock Diamant',
    icon: 'award',
    href: '/app-frn/stock-diamant-fb',
    action: 'consulter',
  },
];

export const getMenuitems = (lst_permissions, loggedUser) => {
  let items = [
    {
      navlabel: true,
      subheader: 'Menu',
      icon: 'mdi mdi-dots-horizontal',
      href: 'Dashboard',
    },
  ];

  MenuItemsRoot.forEach((item) => {
    //get target & action
    let target = item.target ? item.target : null;
    let action = item.action ? item.action : null;
    let is_root = item.is_root ? item.is_root : false;
    if (loggedUser?.role == 'root') items.push(item);
    else if (!target && !item?.collapse) items.push(item);
    else if (!target && is_root && loggedUser?.role == 'root') items.push(item);
    else if (
      target &&
      action &&
      !item?.collapse &&
      IsPermessionGranted(target, action, lst_permissions)
    )
      items.push(item);
    else if (
      target &&
      action &&
      item?.collapse &&
      IsPermessionGranted(target, action, lst_permissions)
    ) {
      let sub_item = item.children.filter(
        (el) =>
          (el?.action && IsPermessionGranted(target, el.action, lst_permissions)) ||
          (el?.is_root && loggedUser?.role == 'root'),
      );
      items.push({ ...item, children: sub_item });
    } else if (item?.collapse && !target && !action && !is_root) {
      let sub_item = item.children.filter(
        (el) =>
          (el?.action && IsPermessionGranted(el?.target, el.action, lst_permissions)) ||
          (el?.is_root && loggedUser?.role == 'root'),
      );
      items.push({ ...item, children: sub_item });
    }
  });

  return items;

  // if (loggedUser?.role == 'root') return items.concat(MenuItemsRoot);
  // else if (loggedUser?.role == 'admin') return items.concat(MenuItemsRoot);
  // else if (loggedUser?.role == 'fournisseur') return items.concat([]);
  // else return items.concat(MenuItemsRoot);
};

export const getMenuitemsFB = () => {
  return [
    {
      navlabel: true,
      subheader: 'Menu',
      icon: 'mdi mdi-dots-horizontal',
      href: 'Dashboard',
    },
    ...MenuItemsFb,
  ];
};

export const IsPermessionGranted = (target, action, claims) => {
  if (Array.isArray(claims))
    return claims.find((el) => el.target == target && el.action == action) ? true : false;
  return false;
};

export const IsUserPermessionGranted = (target, action, claims) => {
  const loggedUser = Storage.getData();
  if (loggedUser?.role == 'root') return true;
  if (Array.isArray(claims))
    return claims.find((el) => el.target == target && el.action == action) ? true : false;
  return false;
};
